export default "__VITE_ASSET__d4a19a17__"